module.exports = __webpack_public_path__ + "static/media/security.fce3d55d.jpg";